export default "__VITE_ASSET__Cu11_fs1__"